import axios from 'axios';
import * as Sentry from '@sentry/react';
import { API_URL } from "../configs";
import { get, isArray, map, isString } from 'lodash';

const createAxiosSentryInstance = () => {
    const axiosInstance = axios.create({
      baseURL: API_URL,
      headers: {
        'Accept': 'application/json',
      },
    });
  
    axiosInstance.interceptors.response.use(
      (response) => response,
      (error) => {
        Sentry.withScope((scope) => {
          if (error.response) {
            scope.setTag('status_code', get(error, 'response.status'));
            scope.setExtra('response', get(error, 'response.data.detail'));
  
            const detail = get(error, 'response.data.detail');
            let serverErrorMessage = 'Unknown server error';
  
            if (isArray(detail)) {
              const messages = map(detail, 'msg').join(', ');
              serverErrorMessage = messages || serverErrorMessage;
            } else if (isString(detail)) {
              serverErrorMessage = detail;
            } else {
              serverErrorMessage = JSON.stringify(detail);
            }
  
            Sentry.captureException(new Error(serverErrorMessage));
          } else {
            scope.setExtra('error', error);
            Sentry.captureException(error);
          }
        });
        return Promise.reject(error);
      }
    );
  
    return axiosInstance;
  };

export default createAxiosSentryInstance;